export default __webpack_public_path__ + "static/media/DeliveryData.4a82cc01.png";